import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../../services/api';
import { ArrowLeft, Lock, User, Mail } from 'lucide-react';
import '../../../styles/admin/ERPProfile.css';

const ERPProfile = () => {
  const [loading, setLoading] = useState(false);
  const [userInfo, setUserInfo] = useState({ email: '', role: '' });
  const [passwordForm, setPasswordForm] = useState({
    current_password: '',
    new_password: '',
    confirm_password: ''
  });
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    // Get user info from token/context
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        setUserInfo({ 
          email: payload.email || payload.sub, 
          role: payload.role || 'admin' 
        });
      } catch (e) {
        console.error('Error parsing token:', e);
      }
    }
  }, []);

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    setMessage({ type: '', text: '' });

    // Validation
    if (passwordForm.new_password !== passwordForm.confirm_password) {
      setMessage({ type: 'error', text: 'Les nouveaux mots de passe ne correspondent pas' });
      return;
    }

    if (passwordForm.new_password.length < 8) {
      setMessage({ type: 'error', text: 'Le nouveau mot de passe doit contenir au moins 8 caractères' });
      return;
    }

    setLoading(true);

    try {
      await api.put('/api/auth/change-password', {
        current_password: passwordForm.current_password,
        new_password: passwordForm.new_password
      });

      setMessage({ type: 'success', text: '✅ Mot de passe modifié avec succès!' });
      setPasswordForm({
        current_password: '',
        new_password: '',
        confirm_password: ''
      });
    } catch (error) {
      const errorMsg = error.response?.data?.detail || 'Erreur lors du changement de mot de passe';
      setMessage({ type: 'error', text: `❌ ${errorMsg}` });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="erp-profile-page">
      <div className="page-header">
        <div className="header-left">
          <Link to="/admin/erp" className="back-button">
            <ArrowLeft size={20} />
            Retour à l'ERP
          </Link>
          <h1>Mon Profil</h1>
        </div>
      </div>

      <div className="profile-container">
        {/* User Info Section */}
        <div className="profile-card info-card">
          <div className="card-header">
            <User size={24} />
            <h2>Informations du compte</h2>
          </div>
          <div className="info-grid">
            <div className="info-item">
              <Mail size={18} />
              <div>
                <label>Adresse email</label>
                <p>{userInfo.email}</p>
              </div>
            </div>
            <div className="info-item">
              <User size={18} />
              <div>
                <label>Rôle</label>
                <p className="role-badge">{userInfo.role}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Change Password Section */}
        <div className="profile-card password-card">
          <div className="card-header">
            <Lock size={24} />
            <h2>Changer mon mot de passe</h2>
          </div>

          <form onSubmit={handlePasswordChange} className="password-form">
            <div className="form-group">
              <label>Mot de passe actuel *</label>
              <input
                type="password"
                value={passwordForm.current_password}
                onChange={(e) => setPasswordForm({...passwordForm, current_password: e.target.value})}
                required
                placeholder="Entrez votre mot de passe actuel"
              />
            </div>

            <div className="form-group">
              <label>Nouveau mot de passe *</label>
              <input
                type="password"
                value={passwordForm.new_password}
                onChange={(e) => setPasswordForm({...passwordForm, new_password: e.target.value})}
                required
                minLength="8"
                placeholder="Minimum 8 caractères"
              />
            </div>

            <div className="form-group">
              <label>Confirmer le nouveau mot de passe *</label>
              <input
                type="password"
                value={passwordForm.confirm_password}
                onChange={(e) => setPasswordForm({...passwordForm, confirm_password: e.target.value})}
                required
                placeholder="Confirmez le nouveau mot de passe"
              />
            </div>

            {message.text && (
              <div className={`message ${message.type}`}>
                {message.text}
              </div>
            )}

            <button 
              type="submit" 
              className="btn-primary"
              disabled={loading}
            >
              {loading ? 'Modification...' : 'Modifier le mot de passe'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ERPProfile;
